export const TabAcceptAssessmentHelpers = {
  data() {
    return {
      tableColumns: [
        {
          title: this.$t("Expediente"),
          type: "custom-html",
          key: "accreditation_applications",
          modifier: (value) => {
            return `<a href="/accreditations/applications/${
              value.id
            }" target="_blank">${value.record || ""}</a>`;
          },
        },
        {
          title: this.$t("Tipo acreditación"),
          type: "custom-html",
          key: "accreditation_applications",
          modifier: (value) => {
            return value.accreditation_type.name;
          },
        },
        {
          title: "Tipo",
          type: "custom-html",
          key: "type",
          modifier: (value) => {
            let val = value;
            if (val == "E") {
              return "EVALUACIÓN";
            }
            if (val == "T") {
              return "TESTIFICACIÓN";
            }
          },
        },
        {
          title: this.$t("Código"),
          type: "text",
          key: "code",
        },
        {
          title: this.$t("Planificado Desde"),
          type: "custom-html",
          key: "date_start",
          modifier: (value) => {
            if (value) {
              return moment(value).format("DD-MM-YYYY");
            }
          },
        },
        {
          title: this.$t("Planificado Hasta"),
          type: "custom-html",
          key: "date_end",
          modifier: (value) => {
            if (value) {
              return moment(value).format("DD-MM-YYYY");
            }
          },
        },
        {
          title: this.$t("Estado"),
          type: "custom-html",
          key: "status",
          modifier: (value) => {
            return value.name;
          },
        },
        // {
        //   title: "Días Disponibles",
        //   type: "custom-html",
        //   key: "eval_test_time",
        //   modifier: (value) => {
        //     let tmp;
        //     if (value) {
        //       if (value.remaining_days > 1) {
        //         tmp = `<span class="badge badge-sm badge-pill badge-success">${value.remaining_days}</span>`;
        //       }
        //       if (value.remaining_days == 1) {
        //         tmp = `<span class="badge badge-sm badge-pill badge-warning">${value.remaining_days}</span>`;
        //       }
        //       if (value.remaining_days == 0) {
        //         tmp = `<span class="badge badge-sm badge-pill badge-danger">${value.remaining_days}</span>`;
        //       }
        //     }
        //     return tmp;
        //   },
        // },
        
      ],
      actionObj: {
        title: this.$t("Acciones"),
        type: "action",
      },
    };
  },
};
